import React from 'react'
import Image from 'next/image'
import { CarouselSlideProps } from '~types'
import { Modal } from '~elements'
import styles from './CarouselSlide.module.scss'
import { NEXT_IMAGE_QUALITY } from '~constants'
import { useWindowSize } from 'utils/hooks'
import { useModal } from 'utils/hooks/useModal'

const CarouselSlide = ({
  imageTitle: title,
  imageDescription: description,
  openImageInModal = true,
  defaultImg: defaultImage,
  mobileImage
}: CarouselSlideProps) => {
  const { isBreakpoint: isBelowBreakpointMd } = useWindowSize('md', '<')
  const responsiveImage = isBelowBreakpointMd ? mobileImage : defaultImage
  const { image } = responsiveImage || {}
  const { isModalOpen, openModal, closeModal } = useModal()

  const ImageComponent = (props: { width: number; height: number }) => {
    const { width, height } = props
    return image?.url ? (
      <Image
        src={image.url}
        alt={responsiveImage?.alt || ''}
        width={width}
        height={height}
        quality={NEXT_IMAGE_QUALITY}
      />
    ) : null
  }

  const handleImageClick = () => {
    openImageInModal && openModal()
  }

  return (
    <div className={styles.slide}>
      <div className={styles['image-container']} onClick={handleImageClick}>
        <ImageComponent width={isBelowBreakpointMd ? 280 : 720} height={isBelowBreakpointMd ? 320 : 520} />
      </div>
      <p>{title}</p>
      {description && <p>{description}</p>}
      {isModalOpen && (
        <Modal closeOnOutsideClick={true} handleModalClose={closeModal} isOpen={isModalOpen} type='media'>
          <ImageComponent width={isBelowBreakpointMd ? 280 : 720} height={isBelowBreakpointMd ? 320 : 520} />
        </Modal>
      )}
    </div>
  )
}

export default CarouselSlide
